module.exports = __webpack_public_path__ + "static/media/GMA-S2100SK-7AER_OR01.f262fc07.png";